<template>
    <div class="common-header">
        <div class="breadcrumb">
            <!--一般的标题显示-->
            <div class="baseInfo-left-base d-s-c">
                <span class="name">{{ menuTitle }}</span>
                <!--插件切换-->
                <div class="el-tabs-container">
                    <el-tabs v-model="activeValue" @tab-click="tabClick">
                        <el-tab-pane :label="item.value" :name="item.key" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {changeRoute} from "../../utils/base";

export default {
    name: "headerMenus",
    props: {
        tabList: {
            type: Array,
            default: () => []
        },
        menuTitle: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            activeValue: '0',
        }
    },
    methods: {
        async tabClick(i) {
            await changeRoute(this.$router, this.$route, {
                tab: i.index
            })
            // let ret = Object.assign(this.$route.query, {
            //     tab: i.index
            // })
            // await this.$router.push({
            //     query: ret
            // })
            this.$emit('clickCallback', i.name)
        }
    },
    async beforeMount() {
        let currentIndex = Number(this.$route.query.tab)
        if (currentIndex >= 0) {
            // 有效参数
            this.activeValue = String(currentIndex)
        }
        await changeRoute(this.$router, this.$route, {
            tab: this.activeValue
        })
    }
}
</script>

<style scoped lang="scss">
.common-header .el-tabs__nav-wrap::after {
    display: none;
}

.common-header .el-tabs-container {
    margin-left: 16px;
    padding-left: 16px;
    border-left: 1px solid #EEEEEE;
}

.common-header .el-tabs__header {
    margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/common/headerMenus.vue